// extracted by mini-css-extract-plugin
module.exports = {"pageNation":"style_pageNation__eh_JV","pageNation__prev":"style_pageNation__prev__bnhKE","pageNation__next":"style_pageNation__next__2iekD","deactivate":"style_deactivate__3X2sM"};